import React, { useState, useEffect } from "react";
import { useForm, FormProvider } from "react-hook-form";
import { Button } from "Components/Button";
import KeyboardHint from "Components/KeyboardHint";
import RadioGroup from "Components/RadioButtons/RadioGroup";
import InfoContentMotionWrapper from "Components/MotionWrapper/InfoContentMotionWrapper";
import { nurturingApproachData } from "Data";
import styles from "Styles/CompanySize.module.css";
import inputStyles from "Styles/Inputs.module.css";

const NurturingApproachFormContent = ({
  submitCB = () => {},
  defaultValue = null,
}) => {
  const [selectedValue, setSelectedValue] = useState(defaultValue);

  const methods = useForm();

  useEffect(() => {
    if (defaultValue) {
      setSelectedValue(defaultValue);
    }
  }, [defaultValue]);

  const radioData = nurturingApproachData.map((item) => ({
    label: item.label,
    value: item.value,
    checked: selectedValue === item.value,
  }));

  const handleChange = (value) => {
    setSelectedValue(value);
  };

  const fieldSubmitCB = (data, e) => {
    e.preventDefault();
    submitCB(selectedValue);
  };

  return (
    <InfoContentMotionWrapper>
      <div className={styles.content}>
        <fieldset className={inputStyles.fieldset}>
          <legend className={inputStyles.legend}>單選題</legend>
          <FormProvider {...methods}>
            <form
              className={inputStyles.form}
              onSubmit={methods.handleSubmit(fieldSubmitCB)}
            >
              <RadioGroup
                radioData={radioData}
                handleChange={handleChange}
                selectedValue={selectedValue}
                name="nurturingApproach"
              />

              <div
                style={{ display: "flex", alignItems: "end", gap: "0.75rem" }}
              >
                <Button
                  disabled={!selectedValue}
                  marginTop
                  type="action"
                  submit
                >
                  OK
                </Button>
                <KeyboardHint />
              </div>
            </form>
          </FormProvider>
        </fieldset>
      </div>
    </InfoContentMotionWrapper>
  );
};

export default NurturingApproachFormContent;
